import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { Plant } from "src/model/class/general classes/plant";

/**
 * Select plant list
 */
export const listPlant = createFeatureSelector<Array<Plant>>(
  AppSettings.KEY_PLANTS
);

/**
 * Select current selected plant
 */
export const selectedPlant = createFeatureSelector<Plant>(
  AppSettings.KEY_CURRENT_PLANT
);
